import React from 'react';
import SettingsBox from 'components/settings-box';
import { ReactComponent as AppSettingsIcon } from 'assets/icons/app_settings.svg';
import { ReactComponent as SecuritySettingsIcon } from 'assets/icons/security_settings.svg';
import { ReactComponent as NotificationSettingsIcon } from 'assets/icons/notification_settings.svg';
// import { ReactComponent as LocationSettingsIcon } from 'assets/icons/location_settings.svg';
import { ReactComponent as PaymentSettingsIcon } from 'assets/icons/payment_settings.svg';
import { ReactComponent as OtherSettingsIcon } from 'assets/icons/others_settings.svg';
import { SettingsItemType } from './types';
import { ROUTE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';

const settingsList: SettingsItemType[] = [
  {
    icon: <AppSettingsIcon className='text-[#F73B58]' />,
    title: 'App Version',
    description: 'Manage foodcourt’s delivery locations',
    route: ROUTE_KEYS.APP_SETTINGS
  },
  // {
  //   icon: <LocationSettingsIcon />,
  //   title: 'Location',
  //   description: 'Manage foodcourt’s delivery locations',
  //   comingSoon: false
  // },
  {
    icon: <PaymentSettingsIcon />,
    title: 'Payment',
    description: 'Manage foodcourt’s delivery locations',
    route: ROUTE_KEYS.PAYMENT_SETTINGS
  },
  {
    icon: <OtherSettingsIcon />,
    title: 'Other',
    description: 'Manage foodcourt’s delivery locations',
    route: ROUTE_KEYS.OTHER_SETTINGS
  },
  {
    icon: <SecuritySettingsIcon />,
    title: 'Security',
    description: 'Manage foodcourt’s delivery locations',
    comingSoon: true
  },
  {
    icon: <NotificationSettingsIcon />,
    title: 'Notification',
    description: 'Manage foodcourt’s delivery locations',
    comingSoon: true
  }
];

const Settings = () => {
  return (
    <div>
      <PageHeaderText title='Settings' />
      <div className='grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:pr-10'>
        {settingsList.map((setting, index) => (
          <SettingsBox
            key={index}
            icon={setting.icon}
            title={setting.title}
            description={setting.description}
            comingSoon={setting.comingSoon}
            route={setting.route}
          />
        ))}
      </div>
    </div>
  );
};

export default Settings;
